import React from 'react';
import './PoweredBy.css';

// Small muted "Powered by ez11" line for guest-facing pages.
// Hidden for white-label organizations (organization.hidePoweredBy).
const PoweredBy = ({ hidden = false, tone = 'light', className = '' }) => {
  if (hidden) return null;
  return (
    <div className={`ez-powered ez-powered-${tone} ${className}`.trim()}>
      <a href="https://ez11.com" target="_blank" rel="noopener">
        Powered by <span className="ez-powered-brand">ez11</span>
      </a>
    </div>
  );
};

export default PoweredBy;
